import React, { useEffect, useState } from "react";
import FancyCard from "../card/fancy-card";
import { BrowserView, MobileView } from 'react-device-detect';
import { IInfoDto } from "@/Domain/Dtos/menu/menuDto";
import { useGetInfo } from "@/Ui/hooks/services/food/useGetInfo";

const CallOrder = () => {
    const [isShowPhonenumber, setIsShowPhoneNumber] = useState<boolean>(false)
    const { data: bohoInfo } = useGetInfo()

    const [menuInfo, setMenuInfo] = useState<IInfoDto>({
        address: '',
        instagram: '',
        phone: ''
    })

    useEffect(() => {

        if (bohoInfo) {
            setMenuInfo(bohoInfo)
        }
    }, [bohoInfo])
    return (
        <div className="z-50 fixed bottom-8 right-8">
            <MobileView>
                <a href={`tel:${menuInfo.phone}`}>
                    <FancyCard
                        isHover={false}
                        isActive
                        text="سفارشت رو ثبت کن!"
                        iconSrc="/svgs/contact/phone-number.svg"
                    />
                </a>
            </MobileView>
            <BrowserView>
                <FancyCard
                    isActive
                    isHover={false}
                    onClick={() => { setIsShowPhoneNumber(!isShowPhonenumber) }}
                    text={isShowPhonenumber ? menuInfo.phone : "سفارشت رو ثبت کن!"}
                    iconSrc="/svgs/contact/phone-number.svg"
                />
            </BrowserView>
        </div>
    )
}

export default React.memo(CallOrder);
